import React, { useMemo, memo } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { VERIFY_DATA_COLUMNS } from "./utils";
import Pagination from "../common/Pagination";

const VerificationScreen = ({ verifyData, index, toggle, open }) => {
  const columns = useMemo(() => VERIFY_DATA_COLUMNS, []);
  const data = useMemo(() => verifyData.products, [verifyData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    prepareRow,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 20 },
    },
    useSortBy,
    usePagination
  );

  return (
    <React.Fragment>
      <div
        onClick={() => toggle(index)}
        className={
          open === index
            ? "d-flex align-items-center justify-content-between rounded-top open pr-4 pl-4"
            : "d-flex align-items-center justify-content-between border rounded p-1  pr-4 pl-4 mb-3"
        }
        style={{ cursor: "pointer" }}
      >
        <h6>
          <strong>Location Name:</strong> {verifyData.location.name}
        </h6>

        {open === index ? (
          <i className="fas fa-chevron-up"></i>
        ) : (
          <i class="fas fa-chevron-down"></i>
        )}
      </div>
      <div
        className={open === index ? "collapse show mb-3" : "collapse mb-3"}
        // id="collapseExample"
      >
        <div
          className={
            open === index
              ? "card card-body rounded-bottom"
              : "card card-body rounded-0"
          }
          style={open ? { borderTop: "0px" } : {}}
        >
          <table
            {...getTableProps()}
            className="styled-table table-bordered table-striped"
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <i className="fas fa-arrow-down ml-2"></i>
                          ) : (
                            <i className="fas fa-arrow-up ml-2"></i>
                          )
                        ) : (
                          ""
                        )}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          {verifyData.products.length ? (
            <Pagination
              gotoPage={gotoPage}
              previousPage={previousPage}
              canNextPage={canNextPage}
              canPreviousPage={canPreviousPage}
              pageOptions={pageOptions}
              pageCount={pageCount}
              nextPage={nextPage}
              setPageSize={setPageSize}
              pageIndex={pageIndex}
              pageSize={pageSize}
            />
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};

export default memo(VerificationScreen);
